import { Component } from '@angular/core';
import * as Bowser from 'bowser';

@Component({
  selector: 'unsupported-page-view',
  templateUrl: './unsupported-page.component.html'
})
export class UnsupportedPageComponent {
  public getBrowserName(): string {
    return Bowser.getParser(window.navigator.userAgent).getBrowserName();
  }

  public getBrowserVersion(): string {
    return Bowser.getParser(window.navigator.userAgent).getBrowserVersion();
  }
}
